import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { FocoItem } from 'src/app/api/models/foco';
import { FocoService } from 'src/app/api/services/foco.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-foco-filter-modal',
    templateUrl: './foco-filter-modal.component.html',
    styleUrls: ['./foco-filter-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FocoFilterModalComponent implements OnInit {
  dataSource = new MatTableDataSource<FocoItem>();
  displayedColumns: string[] = ['codigo', 'nome', 'status'];

  // Declare tipo here
  tipo: string;

  constructor(
    private focoService: FocoService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<FocoFilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { items: FocoItem[], tipo: string }
  ) {
    this.tipo = data.tipo; // Initialize tipo from the data passed to the dialog
    this.dataSource.data = data.items; // Setup the table data
  }

  ngOnInit(): void {
    // Additional initialization can be done here if needed
  }

  updateStatus(item: FocoItem): void {
    // Toggle the status to reflect changes before updating
    item.status = !item.status;
    this.focoService.updateFoco(item).subscribe({
      next: (updatedItem) => {
        this.snackBar.open('Estado do foco atualizado com sucesso', 'Fechar', { duration: 2000 });
        // Optionally, update the item in the dataSource to reflect the change
        const index = this.dataSource.data.findIndex(i => i.id === updatedItem.id);
        this.dataSource.data[index] = updatedItem;
        this.dataSource._updateChangeSubscription(); // Refresh the table to show updated data
      },
      error: (error) => {
        console.error('Erro ao atualizar o estado:', error);
        this.snackBar.open('Erro ao atualizar o estado', 'Fechar', { duration: 2000 });
        // Revert the status change on error
        item.status = !item.status;
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}